type TCartPropertyCoupon = {
  price: number
  priceType: string
  available: number
}
const getSortCartPropertyCoupons = (coupons: TCartPropertyCoupon[]) => {
  return coupons.sort((a, b) => {
    if (a.priceType === 'PERCENT' && b.priceType !== 'PERCENT') {
      return -1
    } else if (a.priceType !== 'PERCENT' && b.priceType === 'PERCENT') {
      return 1
    } else {
      return b.price - a.price
    }
  })
}

export default getSortCartPropertyCoupons
